import React, { useState, useRef, useEffect } from 'react'

export default function Select({ name, label, value, onChange, options = [], error = "", margin = true }) {
    const [open, setOpen] = useState(false)
    const wrapperRef = useRef(null)
    const labelRef = useRef(null)
    const [notchMiddleWidth, setNotchMiddleWidth] = useState(0)

    const selectedOption = options.find(opt => String(opt.value) === String(value))
    const hasValue = value !== undefined && value !== null && value !== ""

    useEffect(() => {
        function handleClickOutside(e) {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setOpen(false)
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [])

    useEffect(() => {
        if (labelRef.current && hasValue) {
            setNotchMiddleWidth(labelRef.current.offsetWidth * 0.8 + 8)
        }
    }, [hasValue, label])

    function handleSelect(optionValue) {
        onChange({ target: { name, value: optionValue } })
        setOpen(false)
    }

    return (
        <div className={"select-wrapper" + (margin ? " mb-4" : "")} ref={wrapperRef} style={{ position: 'relative' }}>
            <div className={"form-outline" + (error ? " is-invalid" : "")}>
                <input
                    type="text"
                    className={"form-control select-input" + (hasValue ? " active" : "") + (error ? " is-invalid" : "")}
                    role="combobox"
                    aria-expanded={open}
                    readOnly
                    value={selectedOption ? selectedOption.label : ""}
                    onClick={() => setOpen(!open)}
                />
                <label ref={labelRef} className="form-label">{label}</label>
                <span
                    className="select-arrow"
                    style={{
                        position: 'absolute',
                        right: '12px',
                        top: '50%',
                        transform: open ? 'translateY(-50%) rotate(180deg)' : 'translateY(-50%)',
                        transition: 'transform 0.2s',
                        pointerEvents: 'none',
                        fontSize: '0.8rem',
                        color: '#666'
                    }}
                >
                    <i className="fas fa-chevron-down"></i>
                </span>
                <div className="form-notch">
                    <div className="form-notch-leading"></div>
                    <div className="form-notch-middle" style={{ width: hasValue ? notchMiddleWidth : 0 }}></div>
                    <div className="form-notch-trailing"></div>
                </div>
            </div>

            {open && (
                <div
                    className="select-dropdown"
                    style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        right: 0,
                        zIndex: 1050,
                        backgroundColor: '#fff',
                        boxShadow: '0 2px 5px 0 rgba(0,0,0,0.16), 0 2px 10px 0 rgba(0,0,0,0.12)',
                        borderRadius: '0.25rem',
                        maxHeight: '200px',
                        overflowY: 'auto',
                        marginTop: '2px'
                    }}
                >
                    {options.map((opt) => (
                        <div
                            key={opt.value}
                            className="select-option"
                            onClick={() => handleSelect(opt.value)}
                            style={{
                                padding: '10px 16px',
                                cursor: 'pointer',
                                backgroundColor: String(opt.value) === String(value) ? '#e3f2fd' : 'transparent',
                                transition: 'background-color 0.2s'
                            }}
                            onMouseEnter={(e) => e.target.style.backgroundColor = '#eee'}
                            onMouseLeave={(e) => e.target.style.backgroundColor = String(opt.value) === String(value) ? '#e3f2fd' : 'transparent'}
                        >
                            {opt.label}
                        </div>
                    ))}
                </div>
            )}

            {/* Hidden select for form compatibility */}
            <select name={name} value={value} onChange={onChange} style={{ display: 'none' }}>
                {options.map((opt) => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
            </select>
        </div>
    )
}
